import React, { useState, useRef, useEffect, useContext } from "react"

import algoliasearch from "algoliasearch/lite"
import {
  InstantSearch,
  Configure,
  // SearchBox,
  // connectHits,
  // connectSearchBox,
  connectAutoComplete,
  // connectStateResults,
  // connectHighlight,
} from "react-instantsearch-dom"
import qs from "qs"

import styles from "./search.module.scss"
import { AppContext } from "./Context"


const searchClient = algoliasearch(
  "WN0K2FPQPE",
  "8e5ab94e5bb026fd40906a5712e6d546"
)

// const createURL = state => `?${qs.stringify(state, { filter: ["query"] })}`

const urlToSearchState = ({ search }) => qs.parse(search.slice(1))

// const CustomHighlight = connectHighlight(({ highlight, attribute, hit }) => {
//   const parsedHit = highlight({
//     highlightProperty: '_highlightResult',
//     attribute,
//     hit,
//   })
//
//   return (
//     <>
//       {parsedHit.map((part, i) => (
//         part.isHighlighted ? <mark key={i}>{part.value}</mark> : <span key={i}>{part.value}</span>
//       ))}
//     </>
//   )
// })

const CustomAutocomplete = connectAutoComplete(
  ({ hits, currentRefinement, refine, navigate, location, searchState }) => {
    const appState = useContext(AppContext)
    const appStateRef = useRef(appState)

    // const [value, setValue] = useState(currentRefinement)

    // useEffect(() => {
    //   setValue(appState.searchTerm)
    // }, [appState.searchTerm])

    // Reset search field value when navigating to non search page
    useEffect(() => {
      if (location.pathname !== "/search")
        appStateRef.current.set({ searchTerm: "" })
    }, [location])

    const inputEl = useRef(null)
    const formEl = useRef(null)

    const redirectQueries = [
      "sandals",
      "flats",
      "boots",
      "sneakers",
      "pumps",
      "bags",
    ]

    const handleSubmit = e => {
      e.preventDefault()
      if (appState.searchTerm === "")
        inputEl.current.focus()
      else if (redirectQueries.includes(appState.searchTerm)) {
        navigate(`/collections/${appState.searchTerm}`)
        document.activeElement.blur()
      } else {
        // navigate(`/search${createURL(searchState)}`)
        navigate(`/search?query=${appState.searchTerm}`)
        document.activeElement.blur()
      }
    }

    // const handleSuggestionClick = hit => {
    //   setValue(hit.title)
    //   refine(hit.title)
    //   console.log(searchState)
    //   formEl.current.submit()
    // }

    return(
      <>
        {/*<SearchBox*/}
        {/*  searchAsYouType={true}*/}
        {/*  showLoadingIndicator={true}*/}
        {/*  className={styles.searchBox}*/}
        {/*/>*/}
        <form
          action=""
          role="search"
          noValidate
          className={styles.form}
          onSubmit={handleSubmit}
          ref={formEl}
        >
          <input
            type="search"
            value={appState.searchTerm}
            onChange={e => {
              // setValue(e.currentTarget.value)
              appState.set({ searchTerm: e.currentTarget.value })
              refine(e.currentTarget.value)
            }}
            className={styles.input}
            placeholder="Search"
            ref={inputEl}
          />
          <input
            type="submit"
            className={styles.submit}
          />
        </form>
        {/*{currentRefinement !== "" &&*/}
        {/*  <ul className={styles.autocompleteList}>*/}
        {/*    {hits.slice(0, 4).map(hit => (*/}
        {/*      // <li key={hit.objectID}>{hit.title}</li>*/}
        {/*      <li*/}
        {/*        key={hit.objectID}*/}
        {/*      >*/}
        {/*        <span*/}
        {/*          role="presentation"*/}
        {/*          onClick={() => handleSuggestionClick(hit)}*/}
        {/*        >*/}
        {/*          <CustomHighlight attribute="title" hit={hit} />*/}
        {/*        </span>*/}
        {/*      </li>*/}
        {/*    ))}*/}
        {/*  </ul>*/}
        {/*}*/}
      </>
    )
  }
)

const Search = ({ location, navigate }) => {
  const [searchState, setSearchState] = useState(urlToSearchState(location))

  const onSearchStateChange = updatedSearchState => {
    setSearchState(updatedSearchState)
  }

  return(
    <InstantSearch
      searchClient={searchClient}
      indexName="tm_headless_search"
      searchState={searchState}
      onSearchStateChange={onSearchStateChange}
      // createURL={createURL}
    >
      <Configure
        hitsPerPage={8}
        typoTolerance={true}
      />
      <CustomAutocomplete
        searchState={searchState}
        navigate={navigate}
        location={location}
      />
      {/*<CustomSearchBox*/}
      {/*  searchState={searchState}*/}
      {/*/>*/}
    </InstantSearch>
  )
}

export default Search
